import { createServiceClient } from 'utils/apiClient'

const processClient = createServiceClient('/process')

export { listActiveProcesses } from './findProcesses'
export default processClient
